import {useAppSelector} from '../../../store/store';
import {CustomerFieldKeys, getValue} from '../../../support/get_data.ts';
import {useIsNavigatingOrPending} from '../../../support/use_is_navigating_or_pending';
import {CustomerField} from './../components/customer_field.tsx';
import {__, transString} from '../../../support/lang/translations';
import {DefaultLocationSelect} from '../../../components/default_location_select/default_location_select.tsx';
import {LanguageSelect} from '../../../components/language_select/language_select.tsx';
import {PageTitle} from '../../../components/page/page_title.tsx';
import {Form} from '../../../components/form/form.tsx';
import {FormGrid} from '../../../components/form/form_grid.tsx';

export function Details() {
    const isLoading = useIsNavigatingOrPending((state) => state.customerInfo.status);
    const meData = useAppSelector((state) => state.customerInfo.me?.customer);
    const customerFields = useAppSelector((state) => state.customerInfo.customerFields);
    const customCustomerFields = customerFields?.filter((customerField) => !customerField?.default);

    const nameData = getValue(meData, CustomerFieldKeys.NAME);
    const prepositionData = getValue(meData, CustomerFieldKeys.PREPOSITION);
    const surNameData = getValue(meData, CustomerFieldKeys.SURNAME);

    const emailData = getValue(meData, CustomerFieldKeys.EMAIL);
    const phoneNumberData = getValue(meData, CustomerFieldKeys.PHONE_NUMBER);
    const birthDayData = getValue(meData, CustomerFieldKeys.BIRTHDAY);

    return (
        <Form>
            <FormGrid custom={true}>
                <fieldset>
                    <legend data-grid-column-start={1} data-grid-column-end={13}>
                        {__('profile.fields.full_name')}
                    </legend>
                    <input
                        data-grid-column-start={1}
                        data-grid-column-end={7}
                        defaultValue={nameData?.value ?? ''}
                        placeholder={nameData?.name ?? transString('profile.fields.name')}
                        name={nameData?.key ?? CustomerFieldKeys.NAME}
                        required={true}
                        disabled={isLoading}
                    />
                    <input
                        data-grid-column-start={7}
                        data-grid-column-end={9}
                        defaultValue={prepositionData?.value ?? ''}
                        placeholder={transString('profile.fields.preposition')}
                        name={prepositionData?.key ?? CustomerFieldKeys.PREPOSITION}
                        disabled={isLoading}
                    />
                    <input
                        data-grid-column-start={9}
                        data-grid-column-end={13}
                        defaultValue={surNameData?.value ?? ''}
                        placeholder={surNameData?.name ?? transString('profile.fields.name')}
                        name={surNameData?.key ?? CustomerFieldKeys.SURNAME}
                        required={true}
                        disabled={isLoading}
                    />
                </fieldset>
            </FormGrid>
            <FormGrid>
                <label>
                    {emailData?.name ?? __('profile.fields.email')}
                    <input
                        defaultValue={emailData?.value ?? ''}
                        name={emailData?.key ?? CustomerFieldKeys.EMAIL}
                        type="email"
                        required={true}
                        disabled={isLoading}
                    />
                </label>
                <label>
                    {phoneNumberData?.name ?? __('profile.fields.phone')}
                    <input
                        defaultValue={phoneNumberData?.value ?? ''}
                        name={phoneNumberData?.key ?? CustomerFieldKeys.PHONE_NUMBER}
                        type="tel"
                        disabled={isLoading}
                    />
                </label>
                <label>
                    {birthDayData?.name ?? __('profile.fields.birthday')}
                    <input
                        defaultValue={birthDayData?.value ?? ''}
                        name={birthDayData?.key ?? CustomerFieldKeys.BIRTHDAY}
                        type="date"
                        required={true}
                        disabled={isLoading}
                    />
                </label>
                <LanguageSelect isLoading={isLoading} isLocked={false} />
                <DefaultLocationSelect isLoading={isLoading} isLocked={false} />
            </FormGrid>

            <PageTitle style={{justifyContent: 'flex-start'}}>
                <h3>{__('profile.titles.other_data')}</h3>
            </PageTitle>

            <FormGrid>
                {customCustomerFields
                    ?.filter(function (customerField) {
                        return customerField?.show_public;
                    })
                    .map(
                        (customerField) =>
                            customerField?.key && (
                                <CustomerField
                                    key={'customer-field-' + customerField.key}
                                    customerField={customerField}
                                    defaultValue={getValue(meData, customerField.key)?.value}
                                    disabled={isLoading || !customerField.edit_public}
                                />
                            ),
                    )}
            </FormGrid>
        </Form>
    );
}
